export default __webpack_public_path__ + "static/JosefinSans-SemiBold-b8523b2518dc76ed6c5a0884f4c2ba18.woff";